import { calculateBattery } from "utils/device";

export const fields = {
	'battery': {
		field: 'battery',
		label: 'Battery',
		server_name: 'battery_reading',
		gradient: (gradientBg, fields) => {
			gradientBg.addColorStop(0, "rgba(44,255,0,0.6)");
			gradientBg.addColorStop(0.20, "rgba(85,240,0,0.6)");
			gradientBg.addColorStop(0.70, "rgba(241,214,0,0.6)");
			gradientBg.addColorStop(0.85, "rgba(255,85,0,0.6)");
			gradientBg.addColorStop(1, "rgba(204,0,0,0.6)");
		},
		transform_data: (device, advancedToggle, row, key) => {
			if (!advancedToggle) {
				row.max = calculateBattery(row.max, false, device.voltage_multiplier);
				row.min = calculateBattery(row.min, false, device.voltage_multiplier);
				row.mean = calculateBattery(row.mean, false, device.voltage_multiplier);
			}

			return row;
		},
		suggestedMin: {
			'battery': 0,
		},
		suggestedMax: {
			'battery': 100
		}
	},
	'rssi': {
		field: 'rssi',
		label: 'Signal Strength',
		server_name: 'rssi,rsrp,rsrq,rssnr',
		gradient: (gradientBg, fields) => {

			if (fields.length > 1) {
				var stop_values = [93, 85, 65, 50, 35, 15, 7];

				for (var fld of fields) {
					var new_values = [];

					for (var value of stop_values) {
						var el = (((value / fields.length) + (25 * (fields.length - (fields.indexOf(fld) + 1)))) / 100);
						new_values.push(el);
					}

					gradientBg.addColorStop(new_values[0], "rgba(195, 0, 0, 0.0)");
					gradientBg.addColorStop(new_values[1], "rgba(195,0,0,0.6)");

					// gradientBg.addColorStop(new_values[0], "rgba(148, 0, 0, 0.6)");
					// gradientBg.addColorStop(new_values[1], "rgba(195,0,0,0.6)");
					gradientBg.addColorStop(new_values[2], "rgba(255,89,0,0.6)");
					gradientBg.addColorStop(new_values[3], "rgba(255,179,0,0.6)");
					gradientBg.addColorStop(new_values[4], "rgba(235, 235, 0, 0.6)");
					// gradientBg.addColorStop(new_values[6], "rgba(150,240,0,0.6)");
					// gradientBg.addColorStop(new_values[7], "rgba(44,255,0,0.6)");

					gradientBg.addColorStop(new_values[5], "rgba(44,255,0,0.6)");
					gradientBg.addColorStop(new_values[6], "rgba(44,255,0,0.0)");
				}
			}
			else {
				gradientBg.addColorStop(1, "rgba(19,0,0,0.6)");
				gradientBg.addColorStop(0.8, "rgba(195,0,0,0.6)");
				gradientBg.addColorStop(0.7, "rgba(255,89,0,0.6)");
				gradientBg.addColorStop(0.6, "rgba(255,179,0,0.6)");
				gradientBg.addColorStop(0.5, "rgba(255,205,0,0.6)");
				gradientBg.addColorStop(0.35, "rgba(208,229,0,0.6)");
				gradientBg.addColorStop(0.2, "rgba(150,240,0,0.6)");
				gradientBg.addColorStop(0, "rgba(44,255,0,0.6)");
			}
		},
		transform_data: (device, advancedToggle, row, key) => {

			if (key == 'rssi') {
				if (row.max > 0) {
					row.min *= -1;
					row.max *= -1;
					row.mean *= -1;
				}
			}
			else if (key == 'rsrq') {
				if (row.mean > -3 || row.mean < -20) {
					row.min /= 10;
					row.max /= 10;
					row.mean /= 10;
				}
			}
			else if (row.mean > 200 || row.mean < -200) {
				row.min /= 10;
				row.max /= 10;
				row.mean /= 10;
			}

			return row;
		},
		suggestedMin: {
			'rssi': -113,
			'rsrp': -150,
			'rsrq': -20,
			'rssnr': -10
		},
		suggestedMax: {
			'rssi': -51,
			'rsrp': -44,
			'rsrq': -3,
			'rssnr': 30
		},
		min: {
			'rssi': -113,
			'rsrp': -150,
			'rsrq': -20,
			'rssnr': -10
		},
		max: {
			'rssi': -51,
			'rsrp': -44,
			'rsrq': -3,
			'rssnr': 30
		}
	},
	'temperature': {
		field: 'temperature',
		label: 'Temperature',
		server_name: 'internal_temp',
		gradient: (gradientBg, fields) => {
			gradientBg.addColorStop(0, "rgba(92,8,0,0.6)");
			gradientBg.addColorStop(0.1, "rgba(223,0,0,0.6)");
			gradientBg.addColorStop(0.2, "rgba(255,128,0,0.6)");
			gradientBg.addColorStop(0.32, "rgba(255,205,0,0.6)");
			gradientBg.addColorStop(0.40, "rgba(222,243,5,0.6)");
			gradientBg.addColorStop(0.48, "rgba(177,249,3,0.6)");
			gradientBg.addColorStop(0.55, "rgba(125,255,0,0.6)");
			gradientBg.addColorStop(0.6, "rgba(60,255,79,0.6)");
			gradientBg.addColorStop(0.65, "rgba(0,255,149,0.6)");
			gradientBg.addColorStop(0.7, "rgba(0,211,255,0.6)");
			gradientBg.addColorStop(0.8, "rgba(0,151,255,0.6)");
			gradientBg.addColorStop(0.9, "rgba(0,89,175,0.6)");
			gradientBg.addColorStop(1, "rgba(0,0,0,0.6)");
		},
		transform_data: (device, advancedToggle, row, key) => {
			return row;
		},
		suggestedMin: {
			'temperature': -20,
		},
		suggestedMax: {
			'temperature': 70,
		},
		min: {
			'temperature': -20,
		},
		max: {
			'temperature': 70
		}
	},
	'humidity': {
		field: 'humidity',
		label: 'Humidity',
		server_name: 'internal_humidity',
		gradient: (gradientBg, fields) => {
			gradientBg.addColorStop(0, "rgba(255,94,0,1)");
			gradientBg.addColorStop(0.1, "rgba(214,118,0,1)");
			gradientBg.addColorStop(0.43, "rgba(141,168,0,0.6)");
			gradientBg.addColorStop(1, "rgba(0,156,21,0.6)");
		},
		transform_data: (device, advancedToggle, row, key) => {
			return row;
		},
		suggestedMin: {
			'humidity': 0,
		},
		suggestedMax: {
			'humidity': 100,
		},
		min: {
			'humidity': 0,
		},
		max: {
			'humidity': 100
		}
	}
};